import React from 'react';
import "./explorePage2.css";

const ExplorePg2 = () => {
    return (
        <div id="page2">
            <div id="page2-container">
                <h1>BUILD</h1>
                <div id="page2-line"></div>
                <h1>CREATE</h1>
                <div id="page2-line"></div>
                <h1>COLLABORATE</h1>
                <div id="page2-line"></div>
                <h1>BUILD</h1>
                <div id="page2-line"></div>
                <h1>CREATE</h1>
                <div id="page2-line"></div>
                <h1>COLLABORATE</h1>
                <div id="page2-line"></div>
                <h1>BUILD</h1>
                <div id="page2-line"></div>
                <h1>CREATE</h1>
                <div id="page2-line"></div>
                <h1>COLLABORATE</h1>
                <div id="page2-line"></div>
                <h1>BUILD</h1>
                <div id="page2-line"></div>
                <h1>CREATE</h1>
                <div id="page2-line"></div>
                <h1>COLLABORATE</h1>
                <div id="page2-line"></div>
                <h1>BUILD</h1>
                <div id="page2-line"></div>
                <h1>CREATE</h1>
                <div id="page2-line"></div>
                <h1>COLLABORATE</h1>
                <div id="page2-line"></div>
            </div>
        </div>
    );
  };
  
export default ExplorePg2;